import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CorrelationService {
    private currentCorrelationId?: string;

    createCorrelationId(): string {
        this.currentCorrelationId = this.newId();
        return this.currentCorrelationId;
    }

    getCurrentCorrelationId(): string | undefined {
        return this.currentCorrelationId;
    }

    private newId(): string {
        if (crypto?.randomUUID) {
            return crypto.randomUUID();
        }

        return `${Date.now()}-${Math.random().toString(36).substring(2)}`;
    }
}
